App.controller('LifeInstructionCtrl', ['$scope', '$sce', '$state', '$http', 'packageService', '$stateParams', function ($scope, $sce, $state, $http, packageService, $stateParams) {
    $scope.stateParams = $stateParams;

    $scope.page = 'life_instruction';
    $scope.$emit('page', $scope.page);

    $scope.step = 'Instrukcje';
    $scope.$emit('step', $scope.step);

    $scope.link = 'root.life.start';
    $scope.$emit('link', $scope.link);
}]);